import ToggleSwitch from "../ToggleSwitch";
import styles from "./StudentList.module.css";

const StudentList = ({
	students = [],
	absentStudents = [],
	onToggleAbsence,
	readOnly = false,
}) => {
	const isStudentAbsent = (studentId) => {
		return absentStudents.some((s) =>
			typeof s === "string" ? s === studentId : s.value === studentId
		);
	};

	if (students.length === 0) {
		return (
			<div className={styles.noResults}>
				<p>No students found.</p>
			</div>
		);
	}

	return (
		<div className={styles.studentsList}>
			{students.map((student) => (
				<div
					key={student.value || student.id}
					className={`${styles.studentItem} ${
						isStudentAbsent(student.value || student.id) ? styles.absent : ""
					}`}
				>
					<span className={styles.studentName}>
						{student.label || student.name}
					</span>
					{!readOnly && (
						<ToggleSwitch
							checked={isStudentAbsent(student.value || student.id)}
							onChange={() => onToggleAbsence(student)}
							label={
								isStudentAbsent(student.value || student.id)
									? "Absent"
									: "Present"
							}
							variant={
								isStudentAbsent(student.value || student.id)
									? "danger"
									: "default"
							}
						/>
					)}
				</div>
			))}
		</div>
	);
};

export default StudentList;
